// Bandeau « Signaux importants du jour » — max 5, alimenté par
// GET /api/leads-engine/alerts/top-signals?limit=5. Zéro mock : si
// le backend renvoie 0 alerte, on n'affiche rien.
import { Zap, ExternalLink, Layers } from "lucide-react";
import { NAVY, CHAMPAGNE, SLATE, GOLD } from
  "@/components/altiora/PremiumUI";
import { humanSignal, humanSource } from "@/lib/altiora-leads-i18n";

export default function TopSignalsBanner({ alerts }) {
  if (!alerts || alerts.length === 0) return null;
  return (
    <section data-testid="top-signals-banner"
             className="rounded-xl p-5 mt-6"
             style={{ background: NAVY, color: "#FBF6EA" }}>
      <div className="flex items-center gap-2 mb-3">
        <Zap className="h-4 w-4" style={{ color: GOLD }} />
        <h2 className="font-serif text-[16px] tracking-tight">
          Signaux importants du jour
        </h2>
        <span className="text-[10px] font-mono uppercase tracking-[0.24em] ml-auto"
              style={{ color: GOLD }}>
          {alerts.length} détecté{alerts.length > 1 ? "s" : ""}
        </span>
      </div>
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {alerts.map((a, i) => (
          <div key={i}
               data-testid={`top-signal-${i}`}
               className="rounded-lg p-3"
               style={{ background: "rgba(251,246,234,0.08)",
                        border: `1px solid ${CHAMPAGNE}33` }}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-serif text-[14px] truncate">
                  {a.entity_name}
                </div>
                <div className="text-[11px] mt-1 flex items-center gap-2 flex-wrap"
                     style={{ color: GOLD }}>
                  <span>{humanSignal(a.signal_type)}</span>
                  <span style={{ color: SLATE }}>· {humanSource(a.source)}</span>
                </div>
              </div>
              {a.cross_source && (
                <Layers className="h-3 w-3 flex-shrink-0"
                        style={{ color: GOLD }} />
              )}
            </div>
            <p className="mt-2 text-[12px]" style={{ color: "#FBF6EA" }}>
              {a.why_it_matters}
            </p>
            <div className="mt-2 flex items-center justify-between text-[10px] font-mono"
                 style={{ color: SLATE }}>
              <span>{a.when}</span>
              {a.source_url && (
                <a href={a.source_url} target="_blank" rel="noreferrer"
                   data-testid={`top-signal-link-${i}`}
                   className="flex items-center gap-1"
                   style={{ color: GOLD }}>
                  Source <ExternalLink className="h-3 w-3" />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
